import { render, staticRenderFns } from "./VEmployerVisaCasesTemplate.vue?vue&type=template&id=7953086f&scoped=true&lang=pug"
import script from "./VEmployerVisaCasesTemplate.vue?vue&type=script&lang=ts"
export * from "./VEmployerVisaCasesTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerVisaCasesTemplate.vue?vue&type=style&index=0&id=7953086f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953086f",
  null
  
)

export default component.exports